import { PostAuditBsDismiss } from 'domain/usecases';
import { BaseHttpService } from 'main/factories/http';

export class RemotePostAuditBsDismiss extends BaseHttpService<PostAuditBsDismiss.Model> implements PostAuditBsDismiss {
  async dismiss(params: PostAuditBsDismiss.Params): Promise<PostAuditBsDismiss.Model | HttpGenericErrorResponse> {
    const payload = {
      accountId: params.accountId,
      dismissedResult: params.dismissedResult,
      comment: params.comment,
      locationId: params.locationId,
    };
    return await this.request('post', payload);
  }
}
